import React from 'react';

const ScrabbleGameContext = React.createContext(null);

export const ScrabbleGameProvider = ({ children, value }) => (
  <ScrabbleGameContext.Provider value={value}>
    {children}
  </ScrabbleGameContext.Provider>
);

export const useScrabbleGameContext = () => {
  const ctx = React.useContext(ScrabbleGameContext);
  if (!ctx) {
    throw new Error('useScrabbleGameContext must be used within a ScrabbleGameProvider');
  }
  return ctx;
};
